<template>
  <va-action-button
    :hide-label="hideLabel"
    :label="label +` (${listState.selected.length})`"
    :icon="icon"
    :text="text"
    plain
    :color="color || 'primary'"
    @click="openConfirmModal"
  ></va-action-button>
</template>

<script>
import ActionButton from "../../../mixins/action-button";

/**
 * Generic customizable button for update bulk actions in VaList component.
 * Shown after items selections. Use `updateMany` data provider method under the hood.
 */
export default {
  mixins: [ActionButton],
  inject: {
    listState: { default: undefined },
  },
  props: {
    /**
     * Selected resources items.
     */
    value: Array,
    /**
     * Conditional before action (Modal window from dash).
     */
    confirmDeleteAction: Boolean,
    /**
     * String for custom endpoint call if needed
     * Now used for pages archive/unarchive
     */
    customEndPoint: {
      type: String,
      default: ""
    },
    /**
     * Data object to send on `updateMany` data provider method.
     * Contains the resource properties to update.
     */
    action: {
      type: Object,
      required: true,
    },
  },
  methods: {
    openConfirmModal() {
      this.$emit("confirmModal", this.listState.selected.length);
    },
    async onBulkUpdate() {
      let value = this.value || this.listState.selected;
      let resourceName = this.listState.resource

      await this.$store.dispatch(`${resourceName}/updateMany`, {
        [resourceName]: value.map(({ id }) => `/api/${resourceName}/${id}`),
        ...this.action,
        customEndPoint: this.customEndPoint ?? ""
      });

      /**
       * Cleanup selected elements
       */
      this.$emit("input", []);
      this.listState.selected = [];
      this.$store.dispatch("api/refresh", this.listState.resource);
    },
  },
  watch: {
    confirmDeleteAction: {
      handler(newVal) {
        if(newVal === true) {
          this.onBulkUpdate()
        }
      },
    },
  }
};
</script>
